import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	remainingDays: {
		id: 'software.main.board-container.board.sprint-remaining-days.remaining-days',
		defaultMessage:
			'{remainingDays} of {totalDays} {totalDays, plural, one {day} other {days}} remaining in sprint',
		description:
			'Main text shown floating above the board. How many days are remaining, and how many days were in the sprint.',
	},
	remainingDaysNoTotal: {
		id: 'software.main.board-container.board.sprint-remaining-days.remaining-days-no-total',
		defaultMessage:
			'{remainingDays} {remainingDays, plural, one {day} other {days}} remaining in sprint',
		description: "If we can't calculate the duration of the sprint we show this message instead",
	},
	startDateLabel: {
		id: 'software.main.board-container.board.sprint-remaining-days.start-date-label',
		defaultMessage: '<Term>Start date:</Term> {date}',
		description:
			'The first day of the sprint, shown in tooltip. The Term is in a dt element on the top, and the Details (the start date) is in dd element underneath.',
	},
	endDateLabel: {
		id: 'software.main.board-container.board.sprint-remaining-days.end-date-label',
		defaultMessage: '<Term>Projected end date:</Term> {date}',
		description:
			'The predicted last day of the sprint, shown in tooltip. The Term is in a dt element on the top, and the Details (the start date) is in dd element underneath.',
	},
});
